// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1RCpA","filesListContainer":"PosDisputesFiles_filesListContainer__A8bqC","filesButton":"PosDisputesFiles_filesButton__2pXEX"};